import { ChangeDetectionStrategy, Component } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { SeoService } from "src/app/services/seo/seo.service";

@Component({
  selector: "app-home",
  templateUrl: "./home.page.html",
  styleUrls: ["./home.page.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomePage {
  public language?: string;

  constructor(public i18n: TranslateService, private seoService: SeoService) {
    this.seoService.setMetadata("home");
  }
}
